import { useState } from 'react';
import PageHeader from '../../../components/PageHeader/PageHeader';
import SentInvoicesTable from '../../../components/ElectronicBilling/SentInvoicesTable';
import { Box, Tabs, Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomTabPanel from '../../../components/Tab/CustomTabPanel';
import ConfiguredRutState from '../../../components/ElectronicBilling/ConfiguredRutState';
import useConfiguredBillingRuts from '../../../hooks/useConfiguredBillingRuts';

const SendInvoice = () => {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(0);
  const { ruts, loading: loadingRuts, error: rutsError, reload } = useConfiguredBillingRuts();

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div>
      {loadingRuts ? <ConfiguredRutState loading /> : rutsError || ruts.length === 0 ? (
        <ConfiguredRutState error={rutsError} onRetry={reload} />
      ) : (
        <>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={tabValue} onChange={handleTabChange} aria-label="billing ruts tabs">
              {ruts.map((rutData) => (
                <Tab key={rutData.rut} label={rutData.rut} />
              ))}
            </Tabs>
          </Box>

          {ruts.map((rutData, index) => (
            <CustomTabPanel key={rutData.rut} value={tabValue} index={index}>
              <PageHeader title={t('emitted_invoices')} subtitle={t('emitted_invoices_desc')} />
              <SentInvoicesTable selectedRut={rutData.rut} provider={rutData.provider} />
            </CustomTabPanel>
          ))}
        </>
      )}
    </div>
  );
};

export default SendInvoice;
